// Verified Google reviews, first names only. Catering first, then meal prep.
// Left out: rating-only reviews, joke reviews and a family member's review.
export const REVIEWS = [
  {
    "name": "Marissa",
    "event": "Wedding, 150 guests",
    "quote": "Dylan & his team did a fantastic job catering my 150ppl wedding. From the bread bar, grazing table board, and one big customized Italian dinner - everyone raved about the food! His team took care of my guests making sure everyone was truly comfortable. From setup to tear down not one issue."
  },
  {
    "name": "Elizabeth",
    "event": "Party after her daughter’s wedding",
    "quote": "Dylan catered our party the day after our daughter’s wedding. He was wonderful to work with! He showed up early and made sure everything was set up perfectly. The food was FANTASTIC! So many of our guests complimented the food, with many people saying the bruschetta and meatballs were the best they had ever had!"
  },
  {
    "name": "Robert",
    "event": "Celebration of life, 120 guests",
    "quote": "Couldn't be happier with the catering service… The food (buffet for 120 people…) was wonderful… I'd recommend Cast Iron Catering to anybody looking for a caterer for any small, medium or large event. Very friendly, great service, GREAT FOOD!"
  },
  {
    "name": "Jim",
    "event": "Church dinner",
    "quote": "This is the first time that our church has used Cast Iron kitchen. They were on time with our food, it came hot, and they set everything up for us. And it was so delicious! Some people were surprised that the chicken and potatoes were gluten-free, It tasted that good! And oh my gosh, the homemade bread they make from scratch, it was to die for."
  },
  {
    "name": "Kaleigh",
    "event": "Engagement party",
    "quote": "Dylan and his team catered our daughter's engagement party. In a word - fantastic! I'll add delicious, tremendous, over-the-top, and without a doubt the best."
  },
  {
    "name": "Payton",
    "event": "Wedding rehearsal dinner",
    "quote": "Dylan did the catering for our wedding rehearsal dinner and I could not be more grateful for the work he did! Our family is Lebanese and everyone at our rehearsal was blown away by the quality of the food we had. People were going back for seconds and thirds!"
  },
  {
    "name": "James",
    "event": "Wedding tasting",
    "quote": "My fiancé and I hired Dylan to cater our wedding! When we got there to try out the food… the setup was more than what we had imagined for a simple taste testing! He went all out! Candle lit, very private, charcuterie board laid out, hugeeee spread! It was perfect. The food.. amazing."
  },
  {
    "name": "Gina",
    "event": "Company events",
    "quote": "We have used Cast Iron Kitchen's catering service several times now for our company functions. It is always a hit and everyone loves it! Very happy with the wonderful food and excellent customer service that Dylan provides!"
  },
  {
    "name": "Brianna",
    "event": "Event in Kirtland",
    "quote": "We had quite a few dietary restrictions and Cast Iron Kitchen was so accommodating and made the ordering process a breeze. The food was great and everyone raved about the chicken parm."
  },
  {
    "name": "Jennifer",
    "event": "Hospital Thanksgiving dinner",
    "quote": "Cast Iron Kitchen did a fantastic job providing a traditional Thanksgiving Dinner for the Pediatric Cancer inpatient unit at Rainbow Babies and Children’s Hospital… We heard great feedback about the meal from the patients and their families. They said it was like a home cooked meal and not mass produced."
  },
  {
    "name": "Kelly",
    "event": "Private event",
    "quote": "Dylan helped me determine the right quantity for an event and was quick to respond to messages. Delivery was prompt and the food was incredible. Everyone raved about the meatballs and balsamic dressing!"
  },
  {
    "name": "Ariel",
    "event": "Event guest",
    "quote": "I recently attended an event catered by Cast Iron Kitchen and I cannot say enough good things. Dylan is incredibly detail oriented… The charcuterie board was amazing, everything was so flavorful and cooked perfectly… I highly, highly recommend Cast Iron Kitchen for any event!"
  },
  {
    "name": "Samantha",
    "event": "Event guest",
    "quote": "I attended an event catered by Cast Iron Kitchen and the food was phenomenal! Everything was so good and most of our attendees went back for seconds."
  },
  {
    "name": "Pamela",
    "event": "Wedding party",
    "quote": "Food was Excellent service great. Staff so friendly and easy to deal with. Our whole wedding party couldn't say enough how good everything was!!! So pleased with everything our go to place for sure!"
  },
  {
    "name": "John",
    "event": "Football event, 50 guests",
    "quote": "Cast Iron Kitchen catered my son’s football event which hosted 50 people. The food was dropped off early and completely set up perfectly for the event. We loved the food and look forward to using them in the future!"
  },
  {
    "name": "Carrie",
    "event": "Private event",
    "quote": "Dylan is great, discusses your order in detail to make sure you get exactly what you want. The food is clean and excellent! He catered an event for us and everyone loved the food!"
  },
  {
    "name": "Kelley",
    "event": "Anniversary party",
    "quote": "The food for this party, catered by Cast Iron Kitchen, was off the chart excellent! All fresh ingredients and simply delicious. The chicken parmigiana was crunchy, moist and filled with flavor and the sauce is spot on homemade."
  },
  {
    "name": "Colleen",
    "event": "Two events",
    "quote": "I have had the pleasure of cast iron kitchen’s catering 2 times now. Every item was delicious. Also at both events the crowd oohed and ahhed about their experience."
  },
  {
    "name": "Peg",
    "event": "Party guest",
    "quote": "I was at a party that Cast Iron Kitchen catered. The food was amazing!! I can’t say what I loved the most, from the pasta, to the meat, to the vegetables, to the pizza, to the desserts. The food experience was one I tell everyone about."
  },
  {
    "name": "Jessica",
    "event": "Two events",
    "quote": "I have been to two events recently that have had Cast Iron cater the meals and the food has been absolutely phenomenal. The meatballs and the chicken cutlets were by far my favorites."
  },
  {
    "name": "Melissa",
    "event": "Event guest",
    "quote": "Dylan's food is full of flavor and his catering provides a variety for all. You can tell that cooking and taking care of people is his passion by the service he provides and the quality of his meals."
  },
  {
    "name": "Erin",
    "event": "Event guest",
    "quote": "Dylan had a wonderful food display, along with healthy and tasty food to accommodate many guests!"
  },
  {
    "name": "Kristian",
    "event": "Catered dinner",
    "quote": "Catered Chicken Parmesan, vodka sauce pasta, and bread and it was absolutely amazing. You could really tell all the food was made with quality, healthy, ingredients. Highly recommend."
  },
  {
    "name": "Katy",
    "event": "Party guest",
    "quote": "I recently attended a party Cast Iron Kitchen catered. The food was all excellent with many delicious options! I will definitely be using them in the future!!!"
  },
  {
    "name": "Formica Plumbing",
    "event": "Baby shower",
    "quote": "I had this food at a baby shower and not only was it delicious but, I also felt good eating it… It was so tasty from the chicken cutlet to the homemade Greek vinaigrette!"
  },
  {
    "name": "CVCF CrossFit",
    "event": "Corporate catering",
    "quote": "Dillon, and his crew at Cast Iron Kitchen always do a great job! They provide excellent customer service, and ask the right questions to help achieve customer satisfaction! If you want a professional supplier to make sure your needs or events are met (and exceeded) I would definitely choose Cast Iron Kitchens."
  },
  {
    "name": "Stacey",
    "event": "",
    "quote": "They now cater making it so much easier to host anything from a family gathering, work meeting, graduation party, to even a wedding and know that you are feeding your guests not only delicious but nutritious meals. I personally have picky eaters who will now only eat “Dylan’s chicken”."
  },
  {
    "name": "Walter",
    "event": "",
    "quote": "Fabulous in every way!! Service is exceptional, food was perfect. Everyone especially loves the homemade bread!! Highly recommend!!!!"
  },
  {
    "name": "Samuel",
    "event": "",
    "quote": "This is the company you want to hire to handle your event’s food! Top notch crew and the food is absolutely amazing"
  },
  {
    "name": "Helen",
    "event": "",
    "quote": "Absolutely amazing! Dylan and his staff really go the extra mile. The food is delicious and the absolute best quality"
  },
  {
    "name": "Thomas",
    "event": "",
    "quote": "5 Stars – Exceptional Catering! Cast Iron Kitchen is an absolute standout when it comes to catering!"
  },
  {
    "name": "George",
    "event": "",
    "quote": "Quality Food made with quality ingredients. From catered meals for your business meetings or home gathering to individual meal prep for busy professionals. Delicious."
  },
  {
    "name": "Frank",
    "event": "",
    "quote": "Incredible family owned company that does things RIGHT. Incredibly delicious food with the highest ingredient quality. Could not recommend them enough."
  },
  {
    "name": "Kevin",
    "event": "",
    "quote": "Probably the best food, service and pricing I know of in this arena. Thank you, Cast Iron!"
  },
  {
    "name": "Mo",
    "event": "",
    "quote": "They do a great job, very customizable, friendly and focused"
  },
  {
    "name": "Tommy",
    "event": "",
    "quote": "Dylan’s food is always freshly prepared with top-quality ingredients, and you can really taste the difference! I highly recommend."
  },
  {
    "name": "Lina",
    "event": "",
    "quote": "I can’t speak highly enough about Cast Iron Kitchen. Dylan is extremely professional and has been a pleasure to work with. The food is outstanding."
  },
  {
    "name": "Lisa",
    "event": "",
    "quote": "I have had food from Cast Iron Kitchen on multiple occasions and I have never been disappointed! Not only is the food delicious, but the customer service is outstanding."
  },
  {
    "name": "Donna",
    "event": "",
    "quote": "I have ordered several times from Cast Iron. The food has been fantastic!! Dylan makes sure everything is perfect from start to finish. The chicken cutlets are the best!"
  },
  {
    "name": "Annie",
    "event": "",
    "quote": "Never disappoints. I am constantly craving the chicken cutlets!! As many other restaurant & catering services seem to be decreasing in quality, this one continues to up its standards! Worth every penny."
  },
  {
    "name": "Jess",
    "event": "",
    "quote": "Best chicken cutlets around! Authentic taste without the flight to Italy! Always delicious and hearty food that is made with quality ingredients."
  },
  {
    "name": "Nick",
    "event": "",
    "quote": "THE BEST! Shop small and local. These meals are great & you can taste the culture and history."
  },
  {
    "name": "Sue",
    "event": "",
    "quote": "Wonderful fresh food, great service. Highly recommend!!!"
  },
  {
    "name": "Tim",
    "event": "",
    "quote": "Amazing food and service"
  },
  {
    "name": "Anna",
    "event": "",
    "quote": "Incredible service, great food! Definitely recommend!"
  },
  {
    "name": "Marty",
    "event": "",
    "quote": "Awesome business! Awesome food!"
  },
  {
    "name": "Sabrina",
    "event": "",
    "quote": "Absolutely amazing experience"
  },
  {
    "name": "Baylan",
    "event": "Team dinner",
    "quote": "Best team dinner of the year"
  },
  {
    "name": "Ryan",
    "event": "",
    "quote": "Great food, great guy."
  },
  {
    "name": "Finn",
    "event": "",
    "quote": "Probably the greatest food ever"
  },
  {
    "name": "Filip",
    "event": "",
    "quote": "Food was amazing."
  },
  {
    "name": "Ty",
    "event": "",
    "quote": "amazing food"
  },
  {
    "name": "Chase",
    "event": "",
    "quote": "Great food from great people!"
  },
  {
    "name": "Erin",
    "event": "",
    "quote": "Amazing food. Highly recommend!"
  },
  {
    "name": "Sarah",
    "event": "Meal prep",
    "quote": "They prioritize high-quality, healthy ingredients and don’t use seed oils, which really sets them apart from other catering/meal prep companies. Everything is fresh, flavorful, and made with care. (The chicken parm is elite btw)"
  },
  {
    "name": "Linda",
    "event": "Meal prep",
    "quote": "Enjoyed each of the meals we purchased. Good value. You’d pay the same or more at a restaurant but this food is a much better quality."
  },
  {
    "name": "Macy",
    "event": "Meal prep",
    "quote": "The meals are so good and makes eating healthier a breeze!"
  },
  {
    "name": "Cheryl",
    "event": "Meal prep",
    "quote": "Cast Iron Kitchen’s food is fresh, tasty, and made with quality ingredients. I have tasted several of their meals and each one is exceptional."
  },
  {
    "name": "David",
    "event": "Meal prep",
    "quote": "Chicken parm and penne pasta are my absolute favorite. Blown away at how good everything tasted while still being super clean. Highly recommend."
  },
  {
    "name": "Juliette",
    "event": "Meal prep",
    "quote": "Great menu choices, consistent quality, delicious food, easy home delivery option."
  },
  {
    "name": "Michael",
    "event": "Meal prep",
    "quote": "Good food that’s good for you, I love everything I get through here."
  },
  {
    "name": "Tom",
    "event": "Meal prep",
    "quote": "The meals are delicious and clean looking very good amounts and variety. I like that he also provides plant based meals if requested."
  },
  {
    "name": "Stanley",
    "event": "Meal prep",
    "quote": "Cast Iron Kitchen has not only delicious and healthy options, but they are also incredibly affordable!! Cast Iron kitchen has saved me time, money, and has helped improve my diet all in one swoop!"
  },
  {
    "name": "Tatiana",
    "event": "Meal prep",
    "quote": "Absolutely loved the meals! Super professional team, always on time with delivery. I LOVE the meatballs and pesto pasta!"
  },
  {
    "name": "Marisa",
    "event": "Meal prep",
    "quote": "I have had many meals from cast iron and not one has disappointed! The meals are fresh, flavorful and incorporate clean ingredients."
  },
  {
    "name": "Julia",
    "event": "Meal prep",
    "quote": "I can’t say enough good things about Cast Iron Kitchen! The food tastes absolutely incredible and each meal I have gotten has been such high quality!"
  },
  {
    "name": "Greg",
    "event": "Meal prep",
    "quote": "Healthy High quality meals. Transparent macros. I highly recommend."
  },
  {
    "name": "Steve",
    "event": "Meal prep",
    "quote": "Quality food, Amazing options. A must try and a local business you should support. I highly recommend to anyone In the area, catering or for a quick meal."
  },
  {
    "name": "Presley",
    "event": "Meal prep",
    "quote": "This food is amazing! Fits all the macro requirements, very healthy and never disappoints!"
  },
  {
    "name": "Gabby",
    "event": "Meal prep",
    "quote": "I absolutely love everything i’ve tried. It’s so tasteful and also so convenient! You have to try!"
  },
  {
    "name": "Stan",
    "event": "Meal prep",
    "quote": "The food is very yummy and the convenience of having it delivered is the icing on the cake. Highly recommend."
  },
  {
    "name": "Denise",
    "event": "Meal prep",
    "quote": "I SO LOVED my Cast Iron Kitchen meals. Every single meal was so yummy. And I just found out they do catering. So I will definitely be using the catering service in the future."
  },
  {
    "name": "Josh",
    "event": "Meal prep",
    "quote": "Cast Iron Kitchen is legit! Every meal I purchased from them was fresh and delicious. Definitely worth every penny."
  },
  {
    "name": "Jenn",
    "event": "Meal prep",
    "quote": "Protein packed convenient meals that taste incredible. More important, they have an owner who really cares about the quality and nutrition of their product!"
  },
  {
    "name": "Mike",
    "event": "Meal prep",
    "quote": "Healthy hearty delicious options… can't go wrong! Very reasonable. Best option for real meal plans!!"
  },
  {
    "name": "Amanda",
    "event": "Meal prep",
    "quote": "Every meal is so fresh and delicious! This is the best meal service I have ever used."
  },
  {
    "name": "Pat",
    "event": "Meal prep",
    "quote": "I love Cast Iron Kitchen!! Every meal I’ve had is always top tier and hits the spot everytime!"
  },
  {
    "name": "Patricia",
    "event": "Meal prep",
    "quote": "It’s always so delicious. The owner is great to work with. I can’t say enough good about Cast Iron Kitchen."
  },
  {
    "name": "Toni",
    "event": "Meal prep",
    "quote": "I had done meal prep in the past, tried a bunch of delivery services, but felt like I was wasting time and money. We have been ordering for over a month and are THRILLED."
  },
  {
    "name": "Calder",
    "event": "Meal prep",
    "quote": "Excellent food! Great macros and quality, cannot recommend enough!"
  },
  {
    "name": "Billy",
    "event": "Meal prep",
    "quote": "Cast Iron Kitchen is the best meal prepping/catering company that I've ever tried. All of the ingredients are high quality, nutrient dense and delicious."
  },
  {
    "name": "Thomas",
    "event": "Meal prep",
    "quote": "I cannot say enough good things about Cast Iron Kitchen and their meals. Please try them, they have legitimately changed my life."
  },
  {
    "name": "Dylan",
    "event": "Meal prep",
    "quote": "Cast Iron Kitchen meals are fantastic! Highly recommend the chicken cutlets and any of the sauces!"
  },
  {
    "name": "Sarah",
    "event": "Meal prep",
    "quote": "They use, and we can tell, fresh ingredients and all meals are tasty and healthy. Highly recommend!"
  },
  {
    "name": "Gino",
    "event": "Meal prep",
    "quote": "Cast Iron Kitchen meals are great for fueling the body. Plus, it tastes good too."
  },
  {
    "name": "George",
    "event": "Meal prep",
    "quote": "The meals that Cast iron provides are high quality made and made with a purpose. If you start buying your meals through them you will not be disappointed."
  },
  {
    "name": "Deme",
    "event": "Meal prep",
    "quote": "This is hands down the best meal delivery service I’ve tried. Blows the other options away!"
  },
  {
    "name": "Vanessa",
    "event": "Meal prep",
    "quote": "My kids also really enjoy these meals and requested that we order more. The quality of the food is very high all around!"
  },
  {
    "name": "Shelbie",
    "event": "Meal prep",
    "quote": "All Dylan’s food is incredible! Vodka sauce is my absolute favorite."
  },
  {
    "name": "Thomas",
    "event": "Meal prep",
    "quote": "The chicken cutlets were the best I’ve ever had! Good clean food all around. 10/10 would recommend Cast Iron Kitchen!"
  },
  {
    "name": "Alec",
    "event": "Meal prep",
    "quote": "Incredibly convenient and always delicious. Every meal I’ve gotten has been excellent. Favorite so far has been the chicken parmesan."
  },
  {
    "name": "Matthew",
    "event": "Meal prep",
    "quote": "Meals are always fresh, flavorful and convenient! Cast Iron Kitchen makes clean eating easy."
  },
  {
    "name": "Shelby",
    "event": "Meal prep",
    "quote": "Chicken cutlets are a staple around here, the salmon is a fave & the SAUCES are so so good."
  },
  {
    "name": "Sarah",
    "event": "Meal prep",
    "quote": "Best part is you know exactly what’s in them. Cast Iron Kitchen uses the best ingredients and my whole family loves every meal without fail."
  },
  {
    "name": "Gavin",
    "event": "Meal prep",
    "quote": "Food is top notch always fresh, great variety and taste. The food delivery was always on time and was reasonably priced."
  },
  {
    "name": "Philip",
    "event": "Meal prep",
    "quote": "My favorites are the chicken cutlets and the sicilian pesto. The chicken cutlets are the best I’ve ever had."
  },
  {
    "name": "Kelly",
    "event": "Meal prep",
    "quote": "Highly recommend!!! My husband and I ordered one of everything and all was delicious."
  },
  {
    "name": "Jon",
    "event": "Meal prep",
    "quote": "The chicken cutlets are gas. Would highly recommend these meals to anyone."
  },
  {
    "name": "Dominic",
    "event": "Meal prep",
    "quote": "Great meals"
  }
]
